import React from 'react';
import cx from 'classnames';
import { useFormContext } from 'react-hook-form';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import { getErrorMessage } from '../utils';
import FieldLabel from './FieldLabel';

import { helperText } from '../../../base-styles/forms.module.css';

import {
  fieldContainer,
  field,
  error as errorStyle,
  errorHidden,
} from '../styles.module.css';

const FieldWrapper = (props) => {
  const { errors } = useFormContext();
  const {
    id,
    required = false,
    description,
    children,
    title,
    error,
    fieldClassName,
    fixed,
    hideLabel,
    hideMessage,
  } = props;

  const errorMessage = getErrorMessage({ errors, error, id, title });
  const errored = !!errorMessage;
  const dummyCharToKeepLineHeight = '.';

  return (
    <div className={cx(fieldContainer, GLOBAL_FORM_STYLES_CLASS)}>
      {!hideLabel && (
        <FieldLabel id={id} required={required && !fixed} title={title} />
      )}
      {description && <span className={helperText}>{description}</span>}
      <div className={fieldClassName != null ? fieldClassName : field}>
        {children}
      </div>
      {!hideMessage && (
        <span className={cx(errorStyle, !errored && errorHidden)}>
          {errored ? errorMessage : dummyCharToKeepLineHeight}
        </span>
      )}
    </div>
  );
};

export default FieldWrapper;
